import React from 'react';
///import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import ListItemButton from '@mui/material/ListItemButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DescriptionIcon from '@mui/icons-material/Description';
import LogoutIcon from '@mui/icons-material/Logout';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LiveTvIcon from '@mui/icons-material/LiveTv';


export default function SwipeableTemporaryDrawer() {
  ///let history = useHistory();
  var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	var selectedCourse = localStorage.getItem('etlSelectCourse'); 
	var mySelectedCourses = JSON.parse(localStorage.getItem('etlMyCourses'));
  const [openSubList, setOpenSubList] = React.useState(true);

  const [openStudyRoom, setOpenStudyRoom] = React.useState(true);

  const [dashboardNav, setDashboardNav] = React.useState(0);
  const [studyMaterialNav, setStudyMaterialNav] = React.useState(0);
  const [selfTestNav, setSelfTestNav] = React.useState(0);
  const [topicTestNav, setTopicTestNav] = React.useState(0);
  const [mockTestNav, setMockTestNav] = React.useState(0);  
  const [dynamicMockTestNav, setDynamicMockTestNav] = React.useState(0);
  const [classTestNav, setClassTestNav] = React.useState(0);
  const [reportNav, setReportNav] = React.useState(0);
  const [teacherHelpNav, setTeacherHelpNav] = React.useState(0);
  const [otherCoursesNav, setOtherCoursesNav] = React.useState(1);


  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  function handleClickSubList(){    
    setOpenSubList(!openSubList);
  };

  // function handleClickCourseList(){    
  //   setOpenCourseList(!openCourseList);
  // };

  function handleStudyRoom(){    
    setOpenStudyRoom(!openStudyRoom);
  };
  
  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  // function goToLocation(url){
  //   window.location.href=url;
  //   ///history.push(url);
  // }

  function logout(){ 
    window.location.href='logout';
  }


  React.useEffect(() => {
    if(window.location.pathname.indexOf("studymaterials")>-1 || window.location.pathname.indexOf("selfassessor")>-1 || window.location.pathname.indexOf("selectclasstest")>-1){ 
      setOpenStudyRoom(true);
    }else if(window.location.pathname.indexOf("selecttopictest")>-1 || window.location.pathname.indexOf("selectmocktest")>-1){ 
      setOpenSubList(true);
    }    

		if(mySelectedCourses && selectedCourse && selectedCourse>=0 && mySelectedCourses[0]){
      
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].dashboard===1){
        setDashboardNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].studyMaterial===1){
        setStudyMaterialNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].selfTest===1){
        setSelfTestNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].topicTest===1){
        setTopicTestNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].mockTest===1){
        setMockTestNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].dynamicMockTest===1){
        setDynamicMockTestNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].classTest===1 && etlStudentObj.schools && etlStudentObj.schools[0] && etlStudentObj.schools[0].schoolId>0){
        setClassTestNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].report===1){
        setReportNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].teacherHelp===1){
        setTeacherHelpNav(1);
      }
      if(mySelectedCourses && selectedCourse && mySelectedCourses[selectedCourse] && mySelectedCourses[selectedCourse].otherCourses===1){
        setOtherCoursesNav(1);
      }else{
        setOtherCoursesNav(0);
      }
      
		}
	}, []); 
  

  
  return (<>
    <List>

      {dashboardNav===1?
      <Link href='dashboard' style={{textDecoration:'none',color:'inherit'}} >  
        <ListItem button selected={window.location.pathname.indexOf("dashboard")>-1?true:false} >
              <ListItemIcon><AssessmentIcon /></ListItemIcon>
              <ListItemText primary="Dashboard" />
        </ListItem> 
      </Link>
      :null}

      {(studyMaterialNav===1 || selfTestNav===1)?
      <>
      <ListItemButton onClick={()=>{handleStudyRoom();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <LibraryBooksIcon />
        </ListItemIcon>
        <ListItemText primary="My Study Room" sx={{fontSize:10}} />
        {openStudyRoom ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openStudyRoom} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
        {studyMaterialNav===1?
          <Link href='studymaterials' style={{textDecoration:'none',color:'inherit'}} >  
            <ListItemButton selected={window.location.pathname.indexOf("studymaterials")>-1?true:false} sx={{pl: 4}}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Study Material" /> 
            </ListItemButton>
          </Link>
        :null}  
        {selfTestNav===1? 
          <Link href='selfassessor' style={{textDecoration:'none',color:'inherit'}} > 
            <ListItemButton selected={window.location.pathname.indexOf("selfassessor")>-1?true:false} sx={{pl: 4}}>
              <ListItemIcon><ArrowRightIcon /></ListItemIcon>
              <ListItemText primary="Smart Learning" />
            </ListItemButton>
          </Link>
        :null}          
        </List>
      </Collapse>
      </>:null}    

      {(topicTestNav===1 || mockTestNav===1 || classTestNav===1)?
      <>
      <ListItemButton onClick={()=>{handleClickSubList();toggleDrawer('left', true)}} >
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary="My Exam Room" />
        {openSubList ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={openSubList} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>       
          {topicTestNav===1?
          <Link href='selecttopictest' style={{textDecoration:'none',color:'inherit'}} >
          <ListItemButton selected={window.location.pathname.indexOf("selecttopictest")>-1?true:false} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Topic Test" />
          </ListItemButton>
          </Link>
          :null}
          {mockTestNav===1?
          <Link href='selectmocktest' style={{textDecoration:'none',color:'inherit'}} >
          <ListItemButton selected={window.location.pathname.indexOf("selectmocktest")>-1?true:false} sx={{ pl: 4 }} >
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Exam Test" />
          </ListItemButton>
          </Link>
          :null}
          {/* {dynamicMockTestNav===1?
          <Link href='ai-mocktest' style={{textDecoration:'none',color:'inherit'}} >
          <ListItemButton selected={window.location.pathname.indexOf("ai-mocktest")>-1?true:false} sx={{ pl: 4 }} >
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="AI Exam Test" />
          </ListItemButton>
          </Link>
          :null} */}
          {classTestNav===1?
          <Link href='selectclasstest' style={{textDecoration:'none',color:'inherit'}} >
          <ListItemButton selected={window.location.pathname.indexOf("selectclasstest")>-1?true:false} sx={{ pl: 4 }}>
            <ListItemIcon><ArrowRightIcon /></ListItemIcon>
            <ListItemText primary="Class Test" />
          </ListItemButton>
          </Link>
          :null}
        </List>
      </Collapse>
      </>
      :null}

      {reportNav===1?
      <Link href='report' style={{textDecoration:'none',color:'inherit'}} >
      <ListItem button selected={window.location.pathname.indexOf("report")>-1?true:false} >
            <ListItemIcon><DescriptionIcon /></ListItemIcon>
            <ListItemText primary="Report & Analytics" />
      </ListItem>
      </Link>
      :null} 

      {/* <ListItem button onClick={()=>{goToLocation('payments')}} >
            <ListItemIcon><PaymentsIcon /></ListItemIcon>
            <ListItemText primary="Payments" />
      </ListItem> */}

      {teacherHelpNav===1?
      <Link href='liveclass' style={{textDecoration:'none',color:'inherit'}} >  
      <ListItem button selected={window.location.pathname.indexOf("liveclass")>-1?true:false} >
            <ListItemIcon><LiveTvIcon /></ListItemIcon>
            <ListItemText primary="My Teacher Help" />
      </ListItem>
      </Link>
      :null}

      {otherCoursesNav===1?  
      <Link href='selectcourse' style={{textDecoration:'none',color:'inherit'}} >  
      <ListItem button selected={window.location.pathname.indexOf("selectcourse")>-1?true:false} >
            <ListItemIcon><AutoAwesomeIcon /></ListItemIcon>
            <ListItemText primary="All Courses" />
      </ListItem> 
      </Link>
      :null}

      <ListItem button onClick={()=>{logout()}} >
            <ListItemIcon><LogoutIcon /></ListItemIcon>
            <ListItemText primary="Logout" />
      </ListItem>

    </List>


  </>);
}
